var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _serializeParams from 'qs/lib/stringify';

var Event = function () {
  function Event(eventName, data) {
    _classCallCheck(this, Event);

    data = data || {};

    this.name = eventName;
    this.type = data.type || eventName;
    this.id = data.id || 0;
    this.channel = data.channel || void 0;
    this.values = data.values || {};
    this.params = data.params || {};
    this.key = data.key || void 0;
    this.code = data.code || void 0;

    if (this.channel && this.params) {
      this.params.channel = this.channel;
    }
  }

  _createClass(Event, [{
    key: 'isChannel',
    value: function isChannel() {
      return this.id != null && this.channel === undefined;
    }
  }, {
    key: 'isChannelToken',
    value: function isChannelToken() {
      return this.channel !== undefined && this.id !== undefined;
    }
  }, {
    key: 'isPong',
    value: function isPong() {
      return this.name === 'pong';
    }
  }, {
    key: 'isMeta',
    value: function isMeta() {
      return this.type === 'meta';
    }
  }, {
    key: 'isResult',
    value: function isResult() {
      return false;
    }
  }, {
    key: 'serialize',
    value: function serialize() {
      return this.name + (Object.keys(this.params).length > 0 ? '?' + _serializeParams(this.params) : '');
    }
  }, {
    key: 'serializeParams',
    value: function serializeParams(params) {
      return _serializeParams(params);
    }
  }, {
    key: 'attributes',
    value: function attributes() {
      return {
        id: this.id,
        channel: this.channel,
        data: this.data,
        token: this.token
      };
    }
  }, {
    key: 'runCallbacks',
    value: function runCallbacks(success, result) {
      this.success = success;
      this.result = result;
      if (this.success === true) {
        return typeof this.successCallback === 'function' ? this.successCallback(this.result) : void 0;
      } else {
        return typeof this.failureCallback === 'function' ? this.failureCallback(this.result) : void 0;
      }
    }
  }]);

  return Event;
}();

export default Event;